import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class UsuariosService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/usuarios';
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'idUsuarios_Permisos': '',
      'idSucursales': '',
      'nombre': '',
      'email': ''
    };
  }

  get(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(filter, search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search, this.authService.getAuthHeaders());
  }

  create(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  update(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  delete(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  getRoles() {
    return this.http.get(this.service_url + '/roles', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }

  public validate(data){
    console.log("validating... ", data);
    
    let error = [];

    // validacion de NOMBRE
    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombre"], 200)){
      error["nombre"] = this.errorService.max(200);
    }
    if(!this.validatorService.required(data["idSucursales"])){
      error["sucursales"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["idUsuarios_Permisos"])){
      error["roles"] = this.errorService.required;
    }
    // validacion de EMAIL
    if(!this.validatorService.required(data["email"])){
      error["email"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["email"], 40)){
      error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }
    
    // validacion de CLAVE
    if(!this.validatorService.required(data["password"])){
      error["password"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["password"], 20)){
      error["password"] = this.errorService.max(50);
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/usuarios.service.ts